import keyMirror from 'helpers/keymirror';

const ONRAMP_ACTION_TYPES = keyMirror({
  FETCH_FIAT_DEPOSIT_QUOTES: null,
});

export { ONRAMP_ACTION_TYPES };
